import React from 'react';

import DatePickerTag4, { IDatePickerTag4 } from '@/components/common/DatePicker/DatePickerTag4';

interface Props {
  datepicker: IDatePickerTag4;
}

export interface IDatePickerRangeProps {
  from: Props;
  to: Props;
}

export default function DatePickerRange({ from, to }: IDatePickerRangeProps) {
  return (
        <div className="row">
            <div className="col">
                <DatePickerTag4 {...from.datepicker} />
            </div>
            <div className="col">
                <DatePickerTag4 {...to.datepicker} />
            </div>
        </div>
  );
}
